module.exports = __webpack_public_path__ + "img/1-13-2.2729518c.png";